import React from 'react'
import Card from '../components/Card'
import { EMAIL_VALIDATION_PATTERN } from '../constants'
import { ERROR_DICT, errorDict } from '../utils/errorDict'
import { useForm } from 'react-hook-form'
import TextField from '../components/TextField'
import Btn from '../components/Btn'
import { useAxios } from '../hooks/useAxios'
import { restore } from '../api/restore'
import BtnIcon from '../components/BtnIcon'
import { ReactSVG } from 'react-svg'

function RestorePage(): React.ReactElement {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm()
  const { loading, fire, error } = useAxios()
  const [done, setDone] = React.useState(false)
  const onSubmit = async (data: any): Promise<void> => {
    const { error } = await fire(restore(data.email))

    if (!error) {
      setDone(true)
    }
  }

  return (
    <div className="auth-layout-view" style={{ maxWidth: '44rem' }}>
      <Card className="auth-layout-view__card auth-card">
        <div className="auth-card__head">
          <h1>{!done ? 'Восстановление пароля' : 'Спасибо!'}</h1>

          <div className="auth-card__head-control _right-side">
            <BtnIcon to="/auth" filled>
              <ReactSVG src={'/i/svg/x.svg'} wrapper={'span'}></ReactSVG>
            </BtnIcon>
          </div>
        </div>
        {!done ? (
          <div className="auth-card__content">
            <p>Введите почту, указанную при регистрации</p>

            <form
              onSubmit={handleSubmit(onSubmit)}
              className="auth-card-form mt-md-5 mt-sm-5"
            >
              <TextField
                control={control}
                rules={{
                  required: true,
                  pattern: {
                    value: EMAIL_VALIDATION_PATTERN,
                    message: ERROR_DICT.email,
                  },
                }}
                hasError={!!errors.email || !!error}
                errorText={
                  (errors.email?.type === 'pattern'
                    ? ERROR_DICT.email
                    : errorDict(errors.email)) || error?.message
                }
                name="email"
                type="email"
                label="Электронная почта"
                required
              ></TextField>

              <footer className="auth-card-form__foot">
                <Btn disabled={loading} loading={loading} type="submit">
                  Отправить
                </Btn>
              </footer>
            </form>
          </div>
        ) : (
          <div className="auth-card__content">
            <p>
              Инструкция по восстановлению пароля отправлена на вашу электронную
              почту
            </p>

            <div className="u-flex u-flexJustifyCenter mt-md-8 mt-sm-6">
              <Btn to={'/auth'}>На главную</Btn>
            </div>
          </div>
        )}
      </Card>
    </div>
  )
}

export default RestorePage
